type TFormatNumberOptions = {
  /**
   * number to format
   */
  value: number
  /**
   * locale to use for formatting
   */
  locale?: string
  /**
   * maximum number of decimal places to show
   */
  maxDecimalPlaces?: Defined<Intl.NumberFormatOptions>['maximumFractionDigits']
  /**
   * minimum number of decimal places to show
   */
  minDecimalPlaces?: Defined<Intl.NumberFormatOptions>['minimumFractionDigits']
}

/**
 * Format number according to the locale (uses correct decimal separator) and maxDecimalPlaces.
 */
export const formatNumber = ({
  value,
  locale = `en`,
  maxDecimalPlaces,
  minDecimalPlaces,
}: TFormatNumberOptions) => {
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: maxDecimalPlaces,
    minimumFractionDigits: minDecimalPlaces,
  }).format(value)
}
